import { Injectable, inject } from '@angular/core';
import { ShivePopupService } from './shive-popup.service';
import { ContextMenuItem } from '../../../shared/data-types/context-menu-item-type';
import { UserOperation } from '../../enums/user-operation';
import { ShiveContextMenuComponent } from '../../../shared/components/context-menu/shive-context-menu/shive-context-menu.component';

@Injectable({
  providedIn: 'root',
})
export class ShiveContextMenuService {
  private readonly shivePopupService = inject(ShivePopupService);

  public openContextMenu(
    anchor: HTMLDivElement,
    contextMenuItems: ContextMenuItem[],
    data: any,
    userOperation: UserOperation,
  ): void {
    if (userOperation !== UserOperation.None) {
      return;
    }

    if (this.shivePopupService.popupRef) {
      this.shivePopupService.close();
    }

    const popupRef = this.shivePopupService.open({
      content: ShiveContextMenuComponent,
      anchor,
    });

    const contextMenuComponent = popupRef.content.instance as ShiveContextMenuComponent;
    contextMenuComponent.contextMenuItems = contextMenuItems;
    contextMenuComponent.data = data;
  }
}
